import { useDispatch } from 'react-redux';
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { loginUser } from '../../slice/authSlice';
import Swal from 'sweetalert2';

// Validation Schema
const loginSchema = yup.object().shape({
    email: yup
        .string()
        .required('Please enter email')
        .email('Please enter a valid email address'),
    password: yup
        .string()
        .required('Please enter password')
        .min(6, 'Password must be at least 6 characters'),
});

const Login = () => {
    const [showPassword, setShowPassword] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const {
        register,
        handleSubmit,
        formState: { errors, isSubmitting },
    } = useForm({
        resolver: yupResolver(loginSchema),
        mode: 'onBlur', // Validates on blur
    });

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const onSubmit = async (data) => {
        try {
            const response = await dispatch(
                loginUser({
                    payload: {
                        ...data
                    }
                })
            )
            if (response?.payload?.code === 200) {
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'success',
                    backdrop: false,
                    title: response?.payload?.message,
                    showConfirmButton: false,
                    timer: 1500,
                }).then(() => {
                    navigate('/dashboard');
                });
            } else {
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'error',
                    backdrop: false,
                    title: response?.payload?.message,
                    showConfirmButton: false,
                    timer: 3000,
                });
            }
        } catch (error) {
            console.error('Login error:', error);
        }
    };

    return (
        <div className="account-pages authentication-bg authentication-bg-pattern d-flex justify-content-center align-items-center">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-8 col-lg-6 col-xl-4">
                        <div className="card bg-pattern">
                            <div className="card-body p-4">
                                <div className="text-center w-75 m-auto">
                                    <div className="auth-logo">
                                        <Link to="/" className="logo logo-dark text-center mb-3">
                                            <img
                                                src={process.env.PUBLIC_URL + '/assets/images/logo-new.svg'}
                                                alt="logo_icon"
                                                style={{ height: '12vh' }}
                                            />
                                        </Link>
                                    </div>
                                </div>

                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <div className="mb-3">
                                        <label htmlFor="email" className="form-label">
                                            Email address
                                        </label>
                                        <input
                                            type="text"
                                            id="email"
                                            className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                                            placeholder="Enter your email"
                                            {...register('email')}
                                        />
                                        {errors.email && (
                                            <div className="invalid-feedback d-block">
                                                {errors.email.message}
                                            </div>
                                        )}
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="password" className="form-label">
                                            Password
                                        </label>
                                        <div className="input-group input-group-merge">
                                            <input
                                                type={showPassword ? 'text' : 'password'}
                                                id="password"
                                                className={`form-control ${errors.password ? 'is-invalid' : ''}`}
                                                placeholder="Enter your password"
                                                {...register('password')}
                                            />
                                            <div
                                                className={`input-group-text ${showPassword ? 'show-password' : ''}`}
                                                onClick={togglePasswordVisibility}
                                                style={{ cursor: 'pointer' }}
                                            >
                                                <span className="password-eye"></span>
                                            </div>
                                        </div>
                                        {errors.password && (
                                            <div className="invalid-feedback d-block">
                                                {errors.password.message}
                                            </div>
                                        )}
                                    </div>

                                    <div className="text-center d-grid">
                                        <button
                                            className="btn btn-primary"
                                            type="submit"
                                            disabled={isSubmitting}
                                        >
                                            {isSubmitting ? 'Logging in...' : 'Log In'}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>

                        <div className="row mt-3">
                            <div className="col-12 text-center">
                                <p>
                                    <Link to="/forget-password" className="text-white ms-1">
                                        Forgot your password?
                                    </Link>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;